/**
 * Business registry the signup company was validated against.
 * - cz: Czech ARES
 * - sk: Slovak RPO (Register právnických osôb)
 * - de: German Handelsregister (via OpenRegister)
 * - pl: Polish CEIDG / KRS / REGON (via NIP)
 * - other: no registry validation (free-text company name)
 */
export const BusinessRegistry = {
  CZ: 'cz',
  SK: 'sk',
  DE: 'de',
  PL: 'pl',
  OTHER: 'other',
} as const;

export const BusinessRegistryValues = Object.values(BusinessRegistry);

export type BusinessRegistry = (typeof BusinessRegistry)[keyof typeof BusinessRegistry];

/** Registries that support lookup (everything except `other`). */
export const SearchableBusinessRegistryValues = BusinessRegistryValues.filter(
  (r) => r !== BusinessRegistry.OTHER,
);

/** Normalized company lookup result returned by GET /registry. */
export interface BusinessRegistryResult {
  registry: BusinessRegistry;
  /** Registry-specific business identifier (IČO for cz/sk, OpenRegister company_id for de). */
  businessId: string;
  name: string;
  vatId?: string;
  /** True for natural-person entrepreneurs (e.g. Czech OSVČ, právní forma 100). */
  isNaturalPerson?: boolean;
  address: {
    street?: string;
    city?: string;
    zip?: string;
    /** ISO 3166-1 alpha-2 country code where available. */
    country?: string;
    /** Human-readable single-line address. */
    formatted?: string;
  };
}
